import { Link } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { seller } from "./legalConfig";

export function LegalLayout({ title, testid, children }) {
  return (
    <div className="min-h-screen bg-slate-50" data-testid={testid}>
      <SiteHeader />

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1
          className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mb-8"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          {title}
        </h1>
        <div className="legal-prose space-y-6 text-slate-700 text-[15px] leading-relaxed">
          {children}
        </div>
      </main>

      <footer className="border-t border-slate-200/70 bg-white/60">
        <div className="max-w-3xl mx-auto px-6 py-8 text-xs text-slate-500 flex flex-wrap items-center justify-between gap-4">
          <span>© {new Date().getFullYear()} {seller.brand}</span>
          <nav className="flex items-center gap-4">
            <Link to="/impressum" className="hover:text-slate-900" data-testid="footer-impressum-link">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-slate-900" data-testid="footer-datenschutz-link">Datenschutz</Link>
            <Link to="/agb" className="hover:text-slate-900" data-testid="footer-agb-link">AGB</Link>
            <Link to="/widerruf" className="hover:text-slate-900" data-testid="footer-widerruf-link">Widerruf</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export function H2({ children }) {
  return (
    <h2
      className="text-xl font-bold text-slate-900 pt-4"
      style={{ fontFamily: "Outfit, sans-serif" }}
    >
      {children}
    </h2>
  );
}

export function H3({ children }) {
  return <h3 className="text-base font-semibold text-slate-900 pt-2">{children}</h3>;
}
